import { useEffect, useState } from 'react'
import { variableName } from './DataLayerGTM'
import log from './log'

export const useInitializeGTM = (gtmId: string) => {
  const [gtmjsFired, setGtmJsFired] = useState(false)

  useEffect(() => {
    if (!gtmId) {
      log('GTM ID is required to initialize Google Tag Manager.')
      return
    }

    /* Verifica se o GTM já foi carregado */
    if (document.getElementById('gtm-script')) {
      log('GTM já inicializado.')
      return
    }

    /* Cria a dataLayer global se ainda não existir */
    if (!window[variableName]) {
      window[variableName] = []
    }

    /* Adiciona o script do GTM ao documento */
    const gtmScript = document.createElement('script')
    gtmScript.id = 'gtm-script'
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
    gtmScript.async = true

    document.head.appendChild(gtmScript)
    setGtmJsFired(true)
    console.log('Google Tag Manager inicializado com sucesso.')
  }, [gtmId])

  return gtmjsFired
}
